import { Component, inject, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastsService } from '@catch/services';
import { TranslocoPipe, TranslocoService } from '@jsverse/transloco';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { JobboardAdapter } from '../../../adapters/jobboard.adapter';
import { SEOService } from '../../../services/seo.service';
import { AnimatedCheckComponent } from '../../snippets/animated-check/animated-check.component';

@UntilDestroy()
@Component({
  selector: 'app-unsubscribe-kira-mail-chat',
  templateUrl: './unsubscribe-kira-mail-chat.component.html',
  styleUrls: ['./unsubscribe-kira-mail-chat.component.scss'],
  imports: [TranslocoPipe, AnimatedCheckComponent],
})
export class UnsubscribeKiraMailChatComponent implements OnInit {
  private readonly jobboardAdapter = inject(JobboardAdapter);
  private readonly route = inject(ActivatedRoute);
  private readonly router = inject(Router);
  private readonly toastsService = inject(ToastsService);
  private readonly seoService = inject(SEOService);
  private readonly translateService = inject(TranslocoService);

  success = false;

  ngOnInit(): void {
    const nonce = this.route.snapshot.queryParams['nonce'];
    const applicationId = this.route.snapshot.params['applicationId'];

    if (!nonce || !applicationId) {
      this.toastsService.alert('ct-library.errors.auth.invalid-link');
      this.router.navigate(['/']);
      return;
    }

    this.seoService.updateTitle(
      this.translateService.translate(
        'jobboard.views.unsubscribe-kira-mail-chat.title'
      )
    );
    this.seoService.updateDescription('');

    this.jobboardAdapter
      .unsubscribeKiraMailChat(+applicationId, nonce)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: () => {
          this.success = true;
        },
        error: () => {
          this.toastsService.alert('ct-library.errors.auth.invalid-link');
          this.router.navigate(['/']);
        },
      });
  }
}
